import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import {
  IllustrationAssistance,
  IllustrationBuilding,
  IllustrationCar,
  IllustrationCivilLiability,
  IllustrationContent,
  IllustrationDriver,
  IllustrationGarden,
  IllustrationLegalAssistance,
  IllustrationMiniOmnium,
  IllustrationOmnium,
  IllustrationPassengers,
  IllustrationPremium,
  IllustrationSwimmingPool,
  IllustrationTheft,
  IllustrationSingleFamily,
  IllustrationModalFamily,
  IllustrationPerson,
  IllustrationSenior,
  IllustrationMoney,
  IllustrationUmbrella,
  IllustrationCare,
} from 'wg-fe-ui';
import IllustrationPartyHat from '../assets/images/IllustrationPartyHat';
import IllustrationOfferView from '../assets/images/IllustrationOfferView';
import IllustrationProspectView from '../assets/images/IllustrationProspectView';
import IllustrationOmniumXL from '../../../sales-conversation/src/assets/IllustrationOmniumXL';
import IllustrationAdvisoryConvo from '../assets/images/IllustrationAdvisoryConvo';
import IllustrationPersonalAnalysis from '../assets/images/IllustrationPersonalAnalysis';
import IllustrationPrice from '../assets/images/IllustrationPrice';
import IllustrationLamp from '../assets/images/IllustrationLamp';
import IllustrationMobility from '../assets/images/IllustrationMobility';
import IllustrationHouse from '../assets/images/IllustrationHouse';
import IllustrationTravel from '../assets/images/IllustrationTravel';
import IllustrationPrivatePerson from '../assets/images/IllustrationPrivatePerson';
import IllustrationSelfEmployed from '../assets/images/IllustrationSelfEmployed';
import IllustrationCompany from '../assets/images/IllustrationCompany';
import IllustrationPersonal from '../assets/images/IllustrationPersonal';
import IllustrationDigital from '../assets/images/IllustrationDigital';
import IllustrationLifeAndFuture from '../assets/images/IllustrationLifeAndFuture';
import IllustrationHobbiesAndInterests from '../assets/images/IllustrationHobbiesAndInterests';
import IllustrationHealth from '../assets/images/IllustrationHealth';
import IllustrationLegal from '../assets/images/IllustrationLegal';
import IllustrationCouple from '../../../design-system/src/assets/illustrations-rounded/IllustrationCouple';
import { IllustrationRounded } from '../../../design-system/src';

interface Props {
  type: string;
  active?: boolean;
}

const IllustrationIconSelector: React.FC<React.PropsWithChildren<Props>> = ({
  type,
  active,
  ...otherProps
}) => {
  const theme = useContext(ThemeContext);

  switch (type?.toLowerCase()) {
    case 'assistance':
      return <IllustrationAssistance {...otherProps} />;
    case 'building':
      return <IllustrationBuilding {...otherProps} />;
    case 'vehicle_at_rest':
    case 'civil_liability':
    case 'vehicle':
      return <IllustrationCar {...otherProps} />;
    case 'civil_liability_family':
    case 'family':
      return <IllustrationCivilLiability {...otherProps} />;
    case 'content':
      return <IllustrationContent {...otherProps} />;
    case 'driver':
      return <IllustrationDriver {...otherProps} />;
    case 'garden':
      return <IllustrationGarden {...otherProps} />;
    case 'legal_assistance':
      return <IllustrationLegalAssistance {...otherProps} />;
    case 'mini_omnium':
      return <IllustrationMiniOmnium {...otherProps} />;
    case 'omnium':
      return <IllustrationOmnium {...otherProps} />;
    case 'passengers':
      return <IllustrationPassengers {...otherProps} />;
    case 'fiscal':
    case 'premium':
      return <IllustrationPremium {...otherProps} />;
    case 'pool':
      return <IllustrationSwimmingPool {...otherProps} />;
    case 'theft':
      return <IllustrationTheft {...otherProps} />;
    case 'with_children':
      return <IllustrationSingleFamily theme={theme} {...otherProps} />;
    case 'single_without_children':
      return <IllustrationPerson theme={theme} {...otherProps} />;
    case 'couple':
      return <IllustrationCouple theme={theme} {...otherProps} />;
    case 'couple_with_children':
      return <IllustrationModalFamily theme={theme} {...otherProps} />;
    case 'elderly':
      return <IllustrationSenior theme={theme} {...otherProps} />;
    case 'partyhat':
      return <IllustrationPartyHat />;
    case 'indirect_losses':
      return <IllustrationMoney {...otherProps} />;
    case 'prospect_view':
      return (
        <IllustrationProspectView
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'offer_view':
      return (
        <IllustrationOfferView
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'advisory_convo':
      return (
        <IllustrationAdvisoryConvo
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'personal_analysis':
      return (
        <IllustrationPersonalAnalysis
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'mobility':
      return (
        <IllustrationMobility
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'private_person':
      return (
        <IllustrationPrivatePerson
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'self_employed':
      return (
        <IllustrationSelfEmployed
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'company':
      return (
        <IllustrationCompany
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'personal':
      return (
        <IllustrationPersonal
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'digital':
      return (
        <IllustrationDigital
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'continuous':
    case 'travel':
      return (
        <IllustrationTravel {...(active && { theme: theme })} {...otherProps} />
      );
    case 'life_and_future':
      return (
        <IllustrationLifeAndFuture
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'hobbies_and_interests':
      return (
        <IllustrationHobbiesAndInterests
          {...(active && { theme: theme })}
          {...otherProps}
        />
      );
    case 'legal':
      return (
        <IllustrationLegal {...(active && { theme: theme })} {...otherProps} />
      );
    case 'health':
      return (
        <IllustrationHealth {...(active && { theme: theme })} {...otherProps} />
      );
    case 'house':
      return (
        <IllustrationHouse {...(active && { theme: theme })} {...otherProps} />
      );
    case 'price':
      return (
        <IllustrationPrice {...(active && { theme: theme })} {...otherProps} />
      );
    case 'lamp':
      return (
        <IllustrationLamp {...(active && { theme: theme })} {...otherProps} />
      );
    case 'funeral_assistance':
      return <IllustrationUmbrella {...otherProps} />;
    case 'financial':
      return <IllustrationMoney {...otherProps} />;
    case 'bereavement_care':
      return <IllustrationCare {...otherProps} />;
    case 'omnium_xl':
      return <IllustrationOmniumXL {...otherProps} />;
    // room sizes
    case 'small':
      return <IllustrationRounded type="ROOM_SIZE_SMALL" isActive={active} />;
    case 'medium':
      return <IllustrationRounded type="ROOM_SIZE_MEDIUM" isActive={active} />;
    case 'large':
      return <IllustrationRounded type="ROOM_SIZE_LARGE" isActive={active} />;
    default:
      return <IllustrationRounded type={type} isActive={active} />;
  }
};

export default IllustrationIconSelector;
